import React from 'react';
import { useButtonStyles } from './hooks/useButtonStyles.js';
import { Loader } from './Loader.js';

const hasHref = (props) => 'href' in props;
const DownloadFileSvg = () => {
    return (React.createElement("svg", { width: "20", height: "21", viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M20.9056 12.2806L21.875 13.25L15 20.125L8.125 13.25L9.09437 12.2806L14.3125 17.4919V5H15.6875V17.4919L20.9056 12.2806ZM21.625 23.625V20.5H23V23.625C23 23.9897 22.8551 24.3394 22.5973 24.5973C22.3394 24.8551 21.9897 25 21.625 25H8.375C8.01033 25 7.66059 24.8551 7.40273 24.5973C7.14487 24.3394 7 23.9897 7 23.625V20.5H8.375V23.625H21.625Z" })));
};
const ArrowSvg = () => {
    return (React.createElement("svg", { width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "currentColor", d: "M10.8081 3.80806C11.0521 3.56398 11.4479 3.56398 11.6919 3.80806L17.9419 10.0581C18.0592 10.1753 18.125 10.3342 18.125 10.5C18.125 10.6658 18.0592 10.8247 17.9419 10.9419L11.6919 17.1919C11.4479 17.436 11.0521 17.436 10.8081 17.1919C10.564 16.9479 10.564 16.5521 10.8081 16.3081L15.9911 11.125H2.5C2.15482 11.125 1.875 10.8452 1.875 10.5C1.875 10.1548 2.15482 9.875 2.5 9.875H15.9911L10.8081 4.69194C10.564 4.44786 10.564 4.05214 10.8081 3.80806Z" })));
};
const ButtonContent = ({ label, loading, icon }) => (React.createElement(React.Fragment, null,
    React.createElement("span", { className: [
            'transition-opacity',
            loading ? 'opacity-0' : '',
            icon ? 'flex items-center gap-x-2.5' : '',
        ].join(' ') },
        label,
        icon === 'download' && React.createElement(DownloadFileSvg, null),
        icon === 'arrow' && React.createElement(ArrowSvg, null)),
    React.createElement(Loader, { visible: loading })));
const Button = ({ className = '', disabled, filled = true, label, loading, rounded = false, size, variant, icon = null, ...props }) => {
    const styles = useButtonStyles({ disabled, filled, rounded, size, variant });
    const attributes = {
        'aria-disabled': disabled,
        className: [
            'relative select-none cursor-pointer whitespace-nowrap',
            styles,
            loading || disabled ? 'pointer-events-none' : '',
            className,
        ].join(' '),
        ...props,
    };
    if (hasHref(props)) {
        return (React.createElement("a", { ...attributes },
            React.createElement(ButtonContent, { ...{ label, loading, icon } })));
    }
    return (React.createElement("button", { ...attributes },
        React.createElement(ButtonContent, { ...{ label, loading, icon } })));
};

export { Button };
//# sourceMappingURL=Button.js.map
